var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgPersonCirclecomponent = function SvgPersonCirclecomponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 0C3.86 0 .5 3.36.5 7.5.5 11.64 3.86 15 8 15c4.14 0 7.5-3.36 7.5-7.5C15.5 3.36 12.14 0 8 0Zm0 2.25a2.247 2.247 0 0 1 2.25 2.25A2.247 2.247 0 0 1 8 6.75 2.247 2.247 0 0 1 5.75 4.5 2.247 2.247 0 0 1 8 2.25Zm-4.5 8.235a5.4 5.4 0 0 0 9 0c-.023-1.492-3.008-2.31-4.5-2.31-1.5 0-4.478.817-4.5 2.31Z",
    fill: "current"
  })));
};
export default SvgPersonCirclecomponent;